import styled from "styled-components";

export const ContactContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;

  @media only screen and (max-width: 742px) {
    & {
      display: block;
      overflow-y: auto;
    }
  }

  & > div {
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    @media only screen and (max-width: 742px) {
      & {
        width: 100%;
      }
    }
  }
`;
